export enum REPORT_TYPE {
  PDF,
  EXCEL,
  JSON,
}
